import React, { useEffect, useState } from "react";
import PageTitle from "../../layouts/PageTitle";
import Lottie from "lottie-react";
import animationData from "../../../images/loding.json";
import { Dropdown, Card, Table, Badge, Col, Spinner } from "react-bootstrap";
import toast from "react-hot-toast";
import Pagination from "../../components/Pagination";
import moment from "moment";
import S3Image from "../../components/S3Image";
import AddConfig from "../../components/Modal/AddConfig";
import { useLocation, useNavigate } from "react-router-dom";
import {
  deleteJobCategory,
  deleteServiceCategory,
  getJobCategoryList,
  getServiceCategoryList,
  postJobCategory,
  postServiceCategory,
  updateJobCategory,
  updateServiceCategory,
} from "../../../services/UserServices/UserService";

export default function CategoryConfig(props) {
  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );
  const navigate = useNavigate();
  const location = useLocation();
  const [addCategoryModal, setAddCategoryModal] = useState(false);
  const [data, setData] = useState([]);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);
  const [editCategory, setEditCategory] = useState(false);
  const [loader, setLoader] = useState(false);
  const [selectedItem, setSelectedItem] = useState();
  const [search, setSearch] = useState("");

  const item = location?.state?.item;

  const pageTittle = item;

  async function categoryListData() {
    setLoader(true);
    if (item === "Job") {
      try {
        const res = await getJobCategoryList(currentPage, 10, search);
        setData(res);
        setLoader(false);
      } catch (error) {
        
        toast.error(error?.response?.data?.message);
      } finally {
        setLoader(false);
      }
    } else {
      try {
        const res = await getServiceCategoryList(currentPage, 10, search);
        setData(res);
        setLoader(false);
      } catch (error) {
    
        toast.error(error?.response?.data?.message);
      } finally {
        setLoader(false);
      }
    }
  }

  const totalItems = data?.data?.data.count;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  useEffect(() => {
    categoryListData();
  }, [currentPage]);

  useEffect(() => {
    setCurrentPage(0);
    const delayDebounce = setTimeout(() => {
      categoryListData();
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [search]);

  useEffect(() => {
    categoryListData();
  }, [currentPage]);

  const deleteHandler = async (id) => {
    setLoader(true);
    const handler =
      item === "Job" ? deleteJobCategory(id) : deleteServiceCategory(id);
    try {
      const res = await handler;
      categoryListData();
      toast.success("Category deleted successfully");
    } catch (error) {
      toast.error("Error occured while deleting category");
      setLoader(false);
    }
  };

  return (
    <div>
      <div className="pb-2">
        <button
          className="btn btn-sm back-btn"
          onClick={() => navigate("/category")}
        >
          Back
        </button>
      </div>
      <PageTitle
        activeMenu={item}
        motherMenu="Category"
        isButton={true}
        action={setAddCategoryModal}
        previousPath={"/category"}
      />
      <div className="pb-2 d-flex justify-content-between">
        <input
          type="text"
          style={{ borderRadius: "0.5rem", width: "300px" }}
          className="form-control"
          placeholder="Search..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>
      <Col className="pr-0">
        {loader ? (
          <div>
            <Lottie
              style={{
                height: "200px",
                marginTop: "45px",
                padding: "30px",
              }}
              animationData={animationData}
            />
          </div>
        ) : (
          <Card>
            <Card.Body>
              <Table>
                <thead style={{ color: "black", textAlign: "center" }}>
                  <tr>
                    <th>
                      <strong>S.NO</strong>
                    </th>
                    <th>
                      <strong>Image</strong>
                    </th>
                    <th>
                      <strong>Category</strong>
                    </th>
                    <th>Created On</th>
                    <th>
                      <strong>Action</strong>
                    </th>
                  </tr>
                </thead>
                <tbody style={{ textAlign: "center" }}>
                  {data?.data?.data?.categories?.map((item, i) => (
                    <tr key={item.id} className={i % 2 === 0 ? "even-row" : ""}>
                      <td>{i + 1}</td>
                      <td>
                        <div
                          style={{
                            backgroundColor: "black",
                            width: "44px",
                            borderRadius: "10px",
                            height: "44px",
                          }}
                        >
                          <S3Image
                            imageKey={item?.image}
                            type={"Profiles"}
                            fileType={"profile-image"}
                            style={"profile-photo"}
                          />
                        </div>
                      </td>
                      <td>
                        {item?.name?.length > 30
                          ? item?.name?.slice(0, 25) + ".."
                          : item?.name}
                      </td>
                      <td>{moment(item?.createdAt).format("ll")}</td>

                      <td>
                        <Dropdown>
                          <Dropdown.Toggle
                            variant="info light"
                            className="light sharp btn btn-info i-false"
                          >
                            {svg1}
                          </Dropdown.Toggle>
                          {!item?.isDeleted && (
                            <Dropdown.Menu>
                              {!item?.isDeleted && (
                                <Dropdown.Item
                                  onClick={() => {
                                    setEditCategory(true);
                                    setSelectedItem(item);
                                  }}
                                >
                                  Edit
                                </Dropdown.Item>
                              )}
                              <Dropdown.Item
                                onClick={() => deleteHandler(item?._id)}
                              >
                                Delete
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          )}
                        </Dropdown>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              {data?.data?.data?.subComponents?.length === 0 && (
                <div className="justify-content-center d-flex my-5 ">
                  Sorry, Data Not Found!
                </div>
              )}
              {data?.data?.data?.subComponents?.length !== 0 && (
                <div className="card-footer clearfix">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="dataTables_info">
                      Page {currentPage * itemsPerPage + 1} to{" "}
                      {totalItems > (currentPage + 1) * itemsPerPage
                        ? (currentPage + 1) * itemsPerPage
                        : totalItems}{" "}
                      of {totalItems} entries
                    </div>

                    <div
                      className="d-flex align-items-center"
                      style={{ gap: "10px" }}
                    >
                      {/* <FilterSearch
                      FilterOption={limitOptions}
                      setFilterType={setItemsPerPage}
                      limitValue={itemsPerPage}
                    /> */}
                      <Pagination
                        pageCount={totalPages}
                        pageValue={currentPage}
                        setPage={setCurrentPage}
                      />
                    </div>
                  </div>
                </div>
              )}
            </Card.Body>
          </Card>
        )}
      </Col>
      {addCategoryModal && (
        <AddConfig
          title={`Add ${item}`}
          buttonTitle={"Add"}
          show={addCategoryModal}
          onHide={() => setAddCategoryModal(false)}
          api={item === "Job" ? postJobCategory : postServiceCategory}
          componentId={item?._id}
          refresh={categoryListData}
        />
      )}
      {editCategory && (
        <AddConfig
          title={`Edit ${item}`}
          buttonTitle={"Save"}
          show={editCategory}
          onHide={() => setEditCategory(false)}
          api={item === "Job" ? updateJobCategory : updateServiceCategory}
          componentId={item?._id}
          refresh={categoryListData}
          selectedItem={selectedItem}
        />
      )}
    </div>
  );
}
